document.addEventListener("DOMContentLoaded", function () {
  $(function () {
    bottomStickyBar();

    $("[data-seeMoreItems]").on("click", function (e) {
      e.preventDefault();

      if ($("[data-moreItems]").hasClass("open")) {
        $("[data-moreItems]").removeClass("open");
        $("[data-seeMoreItems]").find("data-moreItems").stop().slideDown();
      } else {
        $("[data-moreItems]").addClass("open");
        $("[data-seeMoreItems]").find("data-moreItems").stop().slideUp();
      }
    });


    /*
    // Sprawdza czy urządzenie jest iPhone, jesli tak, to dodaje padding bottom do #bottomStickyBar na mobilkach
    if (/iPhone/i.test(navigator.userAgent)) {
      const eachLi = document.querySelectorAll(
        "#bottomStickyBar .info__list > li"
      );
      eachLi.forEach((element) => {
        element.style.paddingBottom = "10px";
      });
    }
    */

  });

  /* ---------------- PRACTICAL INFO BAR - ON MOBILE - HIDE ON SCROLLED DOWN --------------- */
  function bottomStickyBar() {
    if ($("#bottomStickyBar ul li").length > 0) {
      if ($(window).width() < 768) {
        $("body").addClass("moveWidget");
      }
    }
  }
});

window.addEventListener('scroll', function() {
  const fixedElement = document.getElementById('bottomStickyBar');
  const footer = document.getElementsByClassName('mainFooter')[0];
  if (!footer) return;
  const footerRect = footer.getBoundingClientRect();

  // Sprawdzenie, czy footer jest w zasięgu widoku
  if (footerRect.top <= window.innerHeight) {
      // Ukryj element fixed
      fixedElement.style.display = 'none';
  } else {
      // Pokaż element fixed
      fixedElement.style.display = 'block';
  }
});

// Ukryj button "Powrót na wroclaw.pl" kiedy jest narzędziownik
document.addEventListener("DOMContentLoaded", function() {
  if (document.getElementById('bottomStickyBar')) {
      document.getElementById('backToHomepage').style.display = 'none';
  }
});